import { render, staticRenderFns } from "./bigIntValue.vue?vue&type=template&id=9a40ee60"
import script from "./bigIntValue.vue?vue&type=script&lang=ts"
export * from "./bigIntValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports